import { Box } from '@mui/material'
import {
  DASHBOARD_CANDIDATE_STATUS_COLOR,
  DASHBOARD_CANDIDATE_STATUS_LABEL,
  DISPLAY_STATUS_MESSAGES,
  DISPLAY_STATUS_MAP
} from '../../utils/constant'
import { TOOLTIPS } from '../../utils/tooltips'
import CustomChip from '../chip'
import CustomTooltip from '../custom-tooltip'
import Icon from '../icon'
import { memo, useMemo } from 'react'
import CustomFeedbackTooltip from '../../pages/contest/edit/assessment-dashboard/components/CustomFeedbackTooltip'

const CandidateStatusChip = ({
  displayStatus,
  status,
  data,
  disableTooltip = false
}) => {
  const displayLabel = useMemo(() => {
    return (
      DASHBOARD_CANDIDATE_STATUS_LABEL[displayStatus] || displayStatus || status
    )
  }, [displayStatus, status])

  const statusMsg = useMemo(() => {
    return DISPLAY_STATUS_MESSAGES?.[displayStatus]
  }, [displayStatus])

  const rawMessage = useMemo(() => {
    return statusMsg?.message || TOOLTIPS?.[status]
  }, [statusMsg, status])

  const tooltipMessage = useMemo(() => {
    return typeof rawMessage === 'function'
      ? rawMessage(status, data)
      : rawMessage
  }, [rawMessage, status, data])

  const showFeedback = useMemo(() => {
    return (
      displayStatus === DISPLAY_STATUS_MAP.REJECTED ||
      displayStatus === DISPLAY_STATUS_MAP.PRE_OFFER
    )
  }, [displayStatus])

  const feedbackData = useMemo(() => {
    return {
      feedbackTitle:
        displayStatus === DISPLAY_STATUS_MAP.REJECTED
          ? 'Rejection Feedback'
          : 'Pre Offer Feedback',
      feedback: data?.conclusionFeedback || data?.rejectionFeedback,
      feedbackBy: data?.conclusionFeedbackBy || data?.rejectionFeedbackBy
    }
  }, [
    data?.conclusionFeedback,
    data?.conclusionFeedbackBy,
    data?.rejectionFeedback,
    data?.rejectionFeedbackBy,
    displayStatus
  ])

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <CustomChip
        rounded
        size="small"
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span">{displayLabel}</Box>
            {!disableTooltip && tooltipMessage && (
              <CustomTooltip message={tooltipMessage}>
                <Box
                  component="span"
                  sx={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Icon
                    icon="material-symbols:info-outline"
                    style={{ fontSize: 15, color: 'inherit', opacity: 0.9 }}
                  />
                </Box>
              </CustomTooltip>
            )}
          </Box>
        }
        {...(DASHBOARD_CANDIDATE_STATUS_COLOR?.[displayStatus]
          ? { color: DASHBOARD_CANDIDATE_STATUS_COLOR[displayStatus] }
          : {})}
      />

      {showFeedback && feedbackData?.feedback && feedbackData?.feedbackBy && (
        <CustomFeedbackTooltip
          title={feedbackData?.feedbackTitle}
          feedback={feedbackData?.feedback}
          feedbackBy={feedbackData?.feedbackBy}
        >
          <Icon
            icon="mage:message-information"
            style={{
              fontSize: 20,
              color: 'inherit',
              opacity: 0.9
            }}
          />
        </CustomFeedbackTooltip>
      )}
    </Box>
  )
}

export default memo(CandidateStatusChip)
